module.exports = __webpack_public_path__ + "img/rayures.74dfa1e9.png";